import React, { FC, useEffect } from 'react';

import { HStack } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { ButtonGroup } from 'components/index';
import { useSearchParamFunctions } from 'containers/App/hooks/useSearchParamFunctions';
import { TicketsSearchParamsProps } from 'containers/Findings/Tickets/types';
import { viewTicketsByOptions } from 'containers/Findings/Tickets/utils';
import { useSearchParams } from 'hooks/useSearchParams';

export const ViewTicketsBy: FC = () => {
  const dispatch = useDispatch();
  const params = useSearchParams<TicketsSearchParamsProps>();
  const { updateValueInURL } = useSearchParamFunctions();
  const [viewBy, setViewBy] = React.useState(viewTicketsByOptions[0]);

  //set view by
  useEffect(() => {
    setViewBy(
      params?.viewBy === 'findings'
        ? viewTicketsByOptions[1]
        : viewTicketsByOptions[0],
    );
  }, [dispatch, params.viewBy]);

  return (
    <HStack>
      <FilterLabelWrapper>VIEW BY</FilterLabelWrapper>
      <ButtonGroup
        items={viewTicketsByOptions}
        value={viewBy}
        onClick={s => updateValueInURL('viewBy', s?.value)}
      />
    </HStack>
  );
};
